import { addToListActions, MAX_QUANTITY } from "./constants.js";
const handleModalButtonsText = (modalMode, modalFooterButtonsLabels) => {
  switch (modalMode) {
    case addToListActions.CREATE_LIST:
      return {
        first: modalFooterButtonsLabels.createList,
        second: modalFooterButtonsLabels.cancel
      };
    case addToListActions.UPDATED_TO_LIST:
      return {
        first: modalFooterButtonsLabels.viewList,
        second: modalFooterButtonsLabels.continueShopping
      };
    case addToListActions.ADD_TO_LIST:
    default:
      return {
        first: modalFooterButtonsLabels.addItem,
        second: modalFooterButtonsLabels.cancel
      };
  }
};
const handleModalFooterActions = (enableModernApis, state, dispatch, msStore, product, authCookie, locale, agent) => {
  const {
    addToListModalMode,
    clientIdLegacy,
    selectedList,
    selectedListId,
    newListName,
    quantity
  } = state;
  const siteTypeValue = msStore.getPropertiesItemsKeysItem(
    "clientid"
  );
  dispatch({
    payload: { isLoading: true },
    type: addToListActions.CHANGE_LOADING_STATE
  });
  if (addToListModalMode === addToListActions.ADD_TO_LIST) {
    if (!selectedList) {
      const selectErrorMessage = msStore.getKeyValueItem(
        "selectlisterrormessage"
      );
      dispatch({
        payload: {
          hasInputError: true,
          inputErrorText: selectErrorMessage
        },
        type: addToListActions.SHOW_ERROR
      });
    } else if (selectedList && agent) {
      const addToListApiErrorMessage = msStore.getKeyValueItem(
        "addtolistapierrormessage"
      );
      if (!enableModernApis) {
        agent.addToListLegacy({
          clientIdLegacy,
          itemNumber: product.id,
          listId: selectedListId,
          locale,
          localeModuleKey: siteTypeValue,
          operationName: "AddItemToWishList",
          quantity
        }).then(() => {
          dispatch({
            payload: {
              addToListModalMode: addToListActions.UPDATED_TO_LIST,
              errorMsg: "",
              hasInputError: false,
              inputErrorText: "",
              isLoading: false,
              newListName: selectedList,
              showError: false
            },
            type: addToListActions.UPDATE_STATE
          });
        }).catch(() => {
          dispatch({
            payload: {
              errorMsg: addToListApiErrorMessage,
              showError: true
            },
            type: addToListActions.SHOW_ERROR
          });
        });
      } else {
        agent.addToExistingList(
          authCookie,
          quantity,
          product.id,
          selectedListId,
          siteTypeValue
        ).then(() => {
          dispatch({
            payload: {
              addToListModalMode: addToListActions.UPDATED_TO_LIST,
              errorMsg: "",
              hasInputError: false,
              inputErrorText: "",
              isLoading: false,
              newListName: selectedList,
              showError: false
            },
            type: addToListActions.UPDATE_STATE
          });
        }).catch((err) => {
          var _a;
          const { response } = err;
          const { data } = response || {};
          const { message } = data || {};
          if (message === "Max quantity of the list has exceeded 999 items") {
            const maxQuantityErrorMessage = (_a = msStore.getKeyValueItem("maxquantityerrormessage")) == null ? void 0 : _a.replace("{MAX QTY}", `${MAX_QUANTITY}`);
            dispatch({
              payload: {
                hasInputError: true,
                inputErrorText: maxQuantityErrorMessage
              },
              type: addToListActions.SHOW_ERROR
            });
          } else {
            dispatch({
              payload: {
                errorMsg: addToListApiErrorMessage,
                showError: true
              },
              type: addToListActions.SHOW_ERROR
            });
          }
        });
      }
    }
  } else if (addToListModalMode === addToListActions.CREATE_LIST) {
    if (!newListName) {
      const listNameErrorMessage = msStore.getKeyValueItem(
        "listnameerrormessage"
      );
      dispatch({
        payload: {
          hasInputError: true,
          inputErrorText: listNameErrorMessage
        },
        type: addToListActions.SHOW_ERROR
      });
    } else if (newListName && agent) {
      const createListApiErrorMessage = msStore.getKeyValueItem(
        "createlistapierrormessage"
      );
      if (!enableModernApis) {
        agent.addToListLegacy({
          clientIdLegacy,
          itemNumber: product.id,
          listName: newListName,
          locale,
          localeModuleKey: siteTypeValue,
          operationName: "AddNewWishList",
          quantity
        }).then((response) => {
          dispatch({
            payload: {
              addToListModalMode: addToListActions.UPDATED_TO_LIST,
              errorMsg: "",
              hasInputError: false,
              inputErrorText: "",
              isLoading: false,
              selectedListId: response.listId,
              showError: false
            },
            type: addToListActions.UPDATE_STATE
          });
        }).catch(() => {
          dispatch({
            payload: {
              errorMsg: createListApiErrorMessage,
              showError: true
            },
            type: addToListActions.SHOW_ERROR
          });
        });
      } else {
        agent.addToNewList(
          authCookie,
          quantity,
          product.id,
          newListName,
          siteTypeValue
        ).then((response) => {
          dispatch({
            payload: {
              addToListModalMode: addToListActions.UPDATED_TO_LIST,
              errorMsg: "",
              hasInputError: false,
              inputErrorText: "",
              isLoading: false,
              selectedListId: response.id,
              showError: false
            },
            type: addToListActions.UPDATE_STATE
          });
          agent.addToExistingList(
            authCookie,
            quantity,
            product.id,
            response.id,
            siteTypeValue
          ).then(
            () => console.log("Add item to the existing list")
          ).catch(
            (err) => console.log(
              `Add to exisitng list api failed with error: ${err}`
            )
          );
        }).catch((err) => {
          const { response } = err;
          const { data } = response || {};
          const { message } = data || {};
          if (message === "List already exists") {
            const listExistsErrorMessage = msStore.getKeyValueItem(
              "listexistserrormessage"
            );
            dispatch({
              payload: {
                hasInputError: true,
                inputErrorText: listExistsErrorMessage
              },
              type: addToListActions.SHOW_ERROR
            });
          } else {
            dispatch({
              payload: {
                errorMsg: createListApiErrorMessage,
                showError: true
              },
              type: addToListActions.SHOW_ERROR
            });
          }
        });
      }
    }
  } else {
    dispatch({
      payload: { isLoading: false },
      type: addToListActions.CHANGE_LOADING_STATE
    });
  }
};
export {
  handleModalButtonsText,
  handleModalFooterActions
};
